import React, { useState, useEffect } from 'react';
import { Button, IconButton, makeStyles, Typography } from '@material-ui/core';
import MUISnackbar from '@material-ui/core/Snackbar';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import CloseIcon from '@material-ui/icons/Close';
import InfoIcon from '../../icons/InfoIcon';

const useStyles = makeStyles(() => ({
  container: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    width: 'min(400px, calc(100vw - 32px))',
    minHeight: '50px',
    background: 'white',
    padding: '0.75em 0.9em',
    borderRadius: '3px',
    boxShadow: '0 12px 24px 4px rgba(40,42,43,0.2)',
    borderLeft: '4px solid #0263e0',
    fontSize: '0.85rem',
  },
  closeButton: {
    position: 'absolute',
    top: 2,
    right: 2,
  },
  contentContainer: {
    display: 'flex',
    lineHeight: 1.35,
  },
  iconContainer: {
    display: 'flex',
    padding: '0 0.7em 0 0.1em',
    transform: 'translateY(2px)',
  },
  headline: {
    fontWeight: 'bold',
    fontSize: '0.95rem',
    marginBottom: '0.2em',
  },
  sectionLabel: {
    fontWeight: 'bold',
    fontSize: '0.85rem',
    marginTop: '0.4em',
  },
  messageLine: {
    fontSize: '0.8rem',
    marginTop: '0.1em',
    lineHeight: 1.3,
  },
  actionContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: '0.5em',
  },
  confirmButton: {
    textTransform: 'none',
    fontWeight: 600,
    fontSize: '0.8rem',
  },
}));

function isDoctorSession(): boolean {
  const searchStr = window.sessionStorage.getItem('searchStr');
  if (!searchStr) return false;
  const params = new URLSearchParams(searchStr);
  return params.get('isAgentCall') === 'true';
}

export default function ConsentNotification() {
  const classes = useStyles();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (isDoctorSession()) {
      setOpen(true);
    }
  }, []);

  return (
    <MUISnackbar
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      style={{ top: 240 }}
      open={open}
      autoHideDuration={null}
    >
      <div className={classes.container}>
        <IconButton size="small" aria-label="close" className={classes.closeButton} onClick={() => setOpen(false)}>
          <CloseIcon fontSize="small" />
        </IconButton>
        <div className={classes.contentContainer}>
          <div className={classes.iconContainer}>
            <InfoIcon />
          </div>
          <div>
            <Typography variant="body1" className={classes.headline} component="div">
              Recording Consent
            </Typography>
            <Typography variant="body1" component="div" className={classes.sectionLabel}>
              Nurse and Patient consent together
            </Typography>
            <Typography variant="body1" component="div" className={classes.messageLine}>
              "Hi I'm Dr Xx, are you calling from within NSW? (if yes... Is your site using the SDPR?) And we are
              discussing patient xx DOB xx? We video-record consultations for record-keeping purposes, do you consent to
              this consultation being recorded?"
            </Typography>
            <Typography variant="body1" component="div" className={classes.sectionLabel}>
              Patient not yet consented
            </Typography>
            <Typography variant="body1" component="div" className={classes.messageLine}>
              "Hi XXX, I'm Dr Xx, I am an emergency specialist from M-E-D. We video-record consultations for
              record-keeping purposes, do you consent to this consultation being recorded?"
            </Typography>
          </div>
        </div>
        <div className={classes.actionContainer}>
          <Button
            variant="contained"
            color="primary"
            size="small"
            className={classes.confirmButton}
            startIcon={<CheckCircleIcon />}
            onClick={() => setOpen(false)}
          >
            I confirm I've informed both parties
          </Button>
        </div>
      </div>
    </MUISnackbar>
  );
}
